// src/components/BMWArtCarTracker/CarDetails/index.jsx
import React from 'react';
import { Info } from 'lucide-react';
import { Calendar } from 'lucide-react';
import { formatDate, getArtistInfo } from '../../../utils/formatters';
import CarCard from './CarCard';

/**
 * Car Details Panel Component
 * @param {Object} props - Component props
 * @param {Object} props.selectedEvent - Selected event
 * @param {Function} props.onViewCarDetails - View car details handler
 */
const CarDetails = ({ selectedEvent, onViewCarDetails }) => {
  return (
    <div className="w-full h-full bg-white p-4 overflow-y-auto border-l border-gray-200">
      {selectedEvent ? (
        <div>
          <div className="mb-5">
            <h2 className="text-2xl font-light text-gray-900">{selectedEvent.location}</h2>
            <p className="text-lg text-gray-600">{selectedEvent.venue}</p>
            <div className="mt-2 text-sm text-gray-500 flex items-center">
              <Calendar size={16} className="mr-2" />
              {formatDate(selectedEvent.startDate)} - {formatDate(selectedEvent.endDate)}
            </div>
            
            {selectedEvent.active && (
              <div className="mt-3 inline-flex items-center text-sm px-3 py-1 bg-green-100 text-green-800 rounded-full">
                <span className="w-2 h-2 rounded-full bg-green-500 mr-2"></span>
                Currently on display
              </div>
            )}
          </div>
          
          <div className="mb-5">
            <h3 className="text-lg font-medium text-gray-800 mb-3">Featured Art Cars</h3>
            <div className="space-y-5">
              {selectedEvent.cars.map((car, idx) => {
                const carInfo = getArtistInfo(car);
                
                return (
                  <CarCard 
                    key={idx} 
                    carString={car} 
                    carInfo={carInfo} 
                    onViewDetails={onViewCarDetails} 
                  />
                );
              })}
            </div>
          </div>
          
          <div className="text-sm text-gray-500 mt-5 pt-5 border-t border-gray-200">
            <p className="mb-2">
              This exhibition is part of the BMW Art Car Collection 50th Anniversary World Tour.
            </p>
            <p>
              Since 1975, when Alexander Calder transformed a BMW 3.0 CSL into the first BMW Art Car, 
              this collection has grown to include 20 cars designed by renowned artists from around the world.
            </p>
          </div>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center h-full text-gray-500">
          <Info size={48} className="mb-4 opacity-50" />
          <p>Select an event to view details</p>
        </div>
      )}
    </div>
  );
};

export default CarDetails;